<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>培训目录列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/training/create')"
          >创建目录</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入标题"
            v-model="titleinfo"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="cataSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable
        :tableData="cataList"
        :columns="columns"
        @uploadClick="uploadClick"
        @uploadFn="uploadFn"
      />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :user="editUnit"
      @confirm="changeCata"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import {
  catalogList,
  deleteCatalog,
  updateCatalog,
  uploadFile,
  uploadUrl,
  updateInfoStatus
} from '@/api/training'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      rowId: '',
      titleinfo: '',
      editState: false,
      editUnit: {},
      cataList: [],
      columns: [
        {
          field: 'sort',
          title: '排序'
        },
        {
          field: 'title',
          title: '标题'
        },
        {
          field: 'introduce',
          title: '介绍'
        },
        {
          field: 'explainer',
          title: '讲解人'
        },
        {
          field: 'startDt',
          title: '开始时间'
        },
        {
          field: 'endDt',
          title: '结束时间'
        },

        // {
        //   title: '状态',
        //   type: 'switch',
        //   payload: {
        //     field: 'status',
        //     change: (row) => this.changeUnitState(row)
        //   }
        // },
        {
          field: 'remark',
          title: '备注'
        },

        {
          title: '封面图片',
          width: 140,
          type: 'photoPreview',
          payload: {
            field: 'url'
          }
        },
        {
          title: '封面图片上传',
          type: 'upload'
        },
        {
          title: '状态',
          type: 'switch',
          payload: {
            field: 'deactive',
            change: (row) => this.changeUnitState(row)
          }
        },
        {
          title: '操作',
          width: '230',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log(row)
                let edirArr = JSON.parse(JSON.stringify(row))
                // edirArr['status'] = edirArr['status'] === '启用' ? 1 : 2
                this.editUnit = edirArr
                console.log('编辑', this.editUnit)
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '详情',
              type: 'info',
              click: (row) => {
                console.log('详情', row)
                this.$router.push({ path: '/training/filelist', query: row })
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getCataList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getCataList()
    },
    // 列表
    getCataList() {
      let cataparams = {
        title: this.titleinfo,
        pageSize: this.size,
        pageNum: this.page
      }
      catalogList(cataparams).then((res) => {
        if (res.code == 200) {
          let cataArr = res.data.records
          this.total = res.data.total
          this.cataList = cataArr.map((item) => {
            return {
              id: item.id,
              status: item.status,
              deactive: Number(item.status) === 1 ? true : false,
              introduce: item.introduce,
              sort: item.sort,
              title: item.title,
              explainer: item.explainer,
              startDt: item.startDt,
              endDt: item.endDt,
              remark: item.remark,
              url: item.url

              // deactive: item.status == '0' ? true : false
            }
          })
        }
      })
    },
    // 点击上传拿到当前行uuid
    uploadClick(row) {
      console.log(row, '=======================')
      this.rowId = row.id
    },
    // 上传附件
    uploadFn(parma) {
      let that = this
      console.log(parma, that.rowId, '-----------------')
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      that.$loading({
        text: '文件上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '上传')
        if (res.code == 200) {
          let params = {
            id: that.rowId,
            url: res.data.uploadUrl
          }
          uploadUrl(params).then((res) => {
            if (res.code == 200) {
              that.$message({
                message: '上传成功',
                type: 'success'
              })
              setTimeout(() => {
                that.getCataList()
              }, 800)
            } else {
              that.$message({
                type: 'error',
                message: '上传失败!'
              })
            }
          })
        } else {
          that.$message({
            type: 'error',
            message: '上传失败!'
          })
        }
      })
      setTimeout(() => {
        that.$loading().close()
      }, 1500)
    },
    // 状态改变
    changeUnitState(infos) {
      console.log(infos)
      let updateStatusparams = {
        // ...infos,
        id: infos.id,
        status: infos.deactive ? '1' : '2'
      }
      console.log(updateStatusparams)

      updateInfoStatus(updateStatusparams).then((res) => {
        console.log(res.data, '更新')
        // this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getFlieList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
      })
    },
    // 编辑
    changeCata(infos) {
      console.log(infos)
      this.$loading({
        text: '目录更新中'
      })
      let updateparams = {
        // ...infos
        id: infos.id,
        title: infos.title,
        introduce: infos.introduce,
        sort: infos.sort,
        explainer: infos.explainer,
        startDt: infos.startDt,
        endDt: infos.endDt,
        remark: infos.remark,
        status: infos.infos,
        url: infos.url
      }
      updateCatalog(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getCataList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteCatalog(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getCataList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    cataSearch() {
      // this.page = 1
      this.getCataList()
    }
  },
  mounted() {
    this.getCataList()
  }
}
</script>

<style></style>
